import { makeAutoObservable } from 'mobx'

/**
 * Local store of `DelayModal`.
 * Owns the modal's form state: comment text, attached photos with previews,
 * submitting flag and error message.
 * Instantiated per modal mount via `useState(() => new DelayModalStore())`.
 */
export class DelayModalStore {
    comment = ''
    photos: File[] = []
    photoPreviews: string[] = []
    submitting = false
    processing = false
    error: string | null = null

    constructor() {
        makeAutoObservable(this)
    }

    setComment(v: string): void {
        this.comment = v
    }

    addPhoto(file: File): void {
        this.photos = [...this.photos, file]
    }

    addPhotoPreview(preview: string): void {
        this.photoPreviews = [...this.photoPreviews, preview]
    }

    removePhoto(idx: number): void {
        this.photos = this.photos.filter((_, i) => i !== idx)
        this.photoPreviews = this.photoPreviews.filter((_, i) => i !== idx)
    }

    setSubmitting(v: boolean): void {
        this.submitting = v
    }

    setProcessing(v: boolean): void {
        this.processing = v
    }

    setError(v: string | null): void {
        this.error = v
    }

    reset(): void {
        this.comment = ''
        this.photos = []
        this.photoPreviews = []
        this.processing = false
        this.error = null
    }
}
